import React, { Component } from 'react';

class Rentals extends Component {
    state = {}
    render() {
        return (
            <h1 className="text-left">Rentals</h1>
        );
    }
}

export default Rentals;